import { render, staticRenderFns } from "./mix-account.vue?vue&type=template&id=1faa34d0"
import script from "./mix-account.vue?vue&type=script&lang=js"
export * from "./mix-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports